import { applyTheme } from 'orbiter-web-components/src/components/Theme';
import { css } from '@emotion/core';
import { ProjectTheme } from './Theme';
export const contentStyling = (t) => {
    return css `
        // margin: 0;
        background: transparent !important;
        border: none !important;
        color: white;
    `;
};
export const contentContainerStyling = (t) => {
    return css `
        display: flex;
        justify-content: center;
        align-items: center;
    `;
};
export const contentLogoStyling = (t) => {
    return css `
        width: auto !important;
    `;
};
export const defealtStyling = () => {
    return css `
        font-size: ${applyTheme(ProjectTheme, (theme) => ProjectTheme.font.fontSize.default)};
        font-family: ${applyTheme(ProjectTheme, (theme) => ProjectTheme.font.fontFamily.default)};
        font-weight: 300;
    `;
};
export const sectionTitleStyling = (t) => {
    return css `
        margin: ${applyTheme(ProjectTheme, (theme) => ProjectTheme.margin.largeMargin)} 0 !important;
        font-size: ${applyTheme(ProjectTheme, (theme) => ProjectTheme.font.fontSize.h1)} !important;
        font-weight: 600;
        text-transform: uppercase;
    `;
};
export const orangeGradientStyling = (t) => {
    return css `
        background: linear-gradient( -230deg,#e49504 9%,#e64316 90%);
    `;
};
export const redGradientStyling = (t) => {
    return css `
        background: linear-gradient( -30deg, #EC2032 32%, #9F041B 68%);
    `;
};
export const blueGradientStyling = (t) => {
    return css `
        background: linear-gradient(90deg, #04639F 100%);
    `;
};
export const greyGradientStyling = (t) => {
    return css `
        background: linear-gradient(90deg, #444647 100%);
    `;
};
export const containerStyling = (t) => {
    return css `
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
    `;
};
export const mapStyling = (t) => {
    return css `
        width: 550px;
       margin: 40px 0;
       clear: right;
       @media only screen and (max-width: 600px) {
           width: 100%;
       }
    `;
};
export const centerStyling = (t) => {
    return css `
        display: flex;
        justify-content: center;
        margin: 0 !important;
        padding: 0 !important;
    `;
};
export const ColStyling = (t) => {
    return css `
       margin: 0 !important;
       padding: 0 !important;
       max-width: 600px !important;
    `;
};
export const noPaddingStyling = (t) => {
    return css `
       margin: 0 !important;
       padding: 0 !important;
    `;
};
export const logoContainerSyling = (t) => {
    return css `
        width: 60px;
    `;
};
export const logoStyling = (t) => {
    return css `
        height: 50px;
    `;
};
export const copyRightStyling = (t) => {
    return css `
        background: linear-gradient( 50deg, #ffff 32%, #dddd 68%);
        color: #373737;
        font-size: 15px;
        padding: 5px;
        display: flex;
        flex-direction:row;
    `;
};
export const sideFooterStyling = (t) => {
    return css `
        flex: 1;
        align-self: center;
    `;
};
export const floatRightStyling = (t) => {
    return css `
        float: left;
    `;
};
export const floatLeftStyling = (t) => {
    return css `
        float: right;
    `;
};
export const menuIconStyling = (t) => {
    return css `
        height: 100%;
        width: 40px;
    `;
};
//# sourceMappingURL=homeCSS.js.map